import decryptData from "@/utils/decrypt";
import encryptData from "@/utils/addEncrypto";

export default {
  state: { 
    session: {}, 
  },

  getters: { 
    getCurrentSession: state => state.session,
    hasCurrentSession: state => Object.values(state.session).length > 0
  },

  mutations: { 
    setSessionData(state, data) {
      state.session = data;

      window.localStorage.setItem('userData', encryptData(data, '@qG56W5w04YI'))
    },

    deleteSessionData(state) {
      state.session = {}

      window.localStorage.removeItem('userData')
    },

    loadSession(state) {
      if (state.hasCurrentSession) {
        return;
      }

      const raw = window.localStorage.getItem('userData') || null

      if (!raw) {
        return;
      }

      const data = decryptData(raw, "@qG56W5w04YI");

      state.session = data;
    }
  }
};
